import { onBeforeUnmount, onMounted, ref } from 'vue'

type UsePasteImageOnHoverParams = {
  onImagePaste: (file: File, event: ClipboardEvent) => void
  canHandlePaste?: () => boolean
}

export const usePasteImageOnHover = (params: UsePasteImageOnHoverParams) => {
  const isHovered = ref(false)

  const onMouseEnter = () => {
    isHovered.value = true
  }

  const onMouseLeave = () => {
    isHovered.value = false
  }

  const onPaste = (event: ClipboardEvent) => {
    if (!isHovered.value) return
    if (params.canHandlePaste && !params.canHandlePaste()) return

    const file = event.clipboardData?.files?.[0]
    if (!file) return

    params.onImagePaste(file, event)
    event.preventDefault()
  }

  onMounted(() => {
    window.addEventListener('paste', onPaste)
  })

  onBeforeUnmount(() => {
    window.removeEventListener('paste', onPaste)
  })

  return {
    isHovered,
    onMouseEnter,
    onMouseLeave,
  }
}
